// Agent a contact is assigned to: assignedToId, else the legacy assignedAgentId, else the owner.
const ownerFallback = (c) => c.ownerUid || (c.ownerType === 'agent' && c.ownerId) || c.createdBy || '';
export const assignedOf = (c) => (c && (c.assignedToId || c.assignedAgentId || ownerFallback(c))) || '';
export const assignedMatch = (personFilter, c) => !personFilter || assignedOf(c) === personFilter;
